import React from 'react';
import Todo from './Todo';

function TodoList(props) {
  const todos = props.todos
    .filter(({ isComplete }) => {
      return props.hideComplete && isComplete ? false : true;
    })
    .map(({ key, title, isComplete }) => {
      const onComplete = (flag) => {
        props.setComplete(key, flag);
      };
      return (
        <Todo
          key={key}
          title={title}
          isComplete={isComplete}
          onComplete={onComplete}
        />
      );
    });

  return (
    <div>
      <div className="box-shadow">{todos}</div>
    </div>
  );
}

TodoList.defaultProps = {
  todos: [],
};

export default TodoList;
